import React, { Component, PureComponent, useContext, useState, useEffect } from 'react';
import {NavLink, Link, Switch, Route, Redirect} from 'react-router-dom'
import {RootRouterContext} from '../../index.js'
import Contact from './Contact'
import Catering from './Catering'
import FullMenu from './FullMenu'
import Taconight from './Taconight'
import Order from './Order'
import RestaurantMap from './ReataurantMap.js';
import Headers from './Headers'
// import AutoMenu from './AutoMenu'
import AutoMenu from '../../react/AutoMenu'
import CartBar from './CartBar'
import LocationsView from './LocationsView'
import FormJob from './FormJob'
import ScrollToTop from '../../react/ScrollToTop.js';
import BakeryVideo from "./BakeryVideo"
import FeaturedProducts from './FeaturedProducts.js';
import HamburgerMenu from './HamburgerMenu.js';
import MenuCategoriesPreview from './MenuCategoriesPreview.js';
import './index.scss'
import './altStyleA.scss'
// import {PromoOverlay} from './PromoOverlay.js';
import Bogo from './Bogo.js';
import LogoBar from './svg/LogoBar'
import Star from './svg/Star'
import lancersBadge from './assets/lancers-badge.png'
import './ThemeToggle/theme_night.scss'
import './brand2026.scss' // must load last: overrides the legacy Lancers styles
import {Helmet} from "react-helmet";
import MainNavigation from './MainNavigation.js';
import ProductSlideshow from './ProductSlideshow.js';
import { InstagramEmbed } from 'react-social-media-embed';
import locationsData, {siteData} from './locationsData.js';
import StPatricksPromo from './StPatricksPromo';
import EasterPromo from './EasterPromo';
import MothersDayPromo from './MothersDayPromo';
import FathersDayPromo from './FathersDayPromo';
 
export const customOrderAppPaths = ["/menu", "/order"]
export const StickyTopBar = () => { return null }
 
export {locationsData as locations}

// merge locations data with locations metadata


export const pages = [
  {path: "/order", label: "Order"},
  {path: "/menu", label: "Menu"},
  {path: "/hqusers/storeRedirect/:anything", label: "Catering", hideFromNav: true, component: () => <Redirect to="/"></Redirect>},
]

export const multiSitePages = [
  // {path: "/catering", label: "Menu", component: Menu},
  // {path: "/catering", label: "Catering", component: Catering},
  // {path: "/christmas", label: "Christmas Menu", component: Bogo},
  {path: "/full-menu", label: "Full Menu", component: FullMenu},
  {path: "/contact", label: "Contact", component: Contact},
  {path: "/catering", label: "Catering", component: Catering},
  {path: "/order", label: "Order", component: Order},
]

// Paths shown in the top nav / hamburger. Everything in multiSitePages keeps
// its route; this only controls visibility.
export const navVisiblePaths = ["/full-menu"]

export function SiteNav ({shopId}) {

    const {rootHistory} = useContext(RootRouterContext)


    return (
      <>
      <CartBar shopId={shopId}></CartBar>
    <nav role="navigation" aria-label="navigation">
    
   
  </nav>
  </>
  )
}



export function MultilocationHome () {
  const [shops, setShops] = useState([])
  const [shop, setShop] = useState(null)
  let menuURL = `https://afoodapart.com/api/menu/lancers`
  // useEffect(() => {
  //   const fetchShops = async () => {
  //     // fetch 2 shops shiso and shisooaks

  //     const fetchShiso = fetch(`https://p39pffu1q4.execute-api.us-west-1.amazonaws.com/v18-sushi-mods/settings?r_id=shiso`);
  //     const fetchShisooaks = fetch(`https://p39pffu1q4.execute-api.us-west-1.amazonaws.com/v18-sushi-mods/settings?r_id=shisooaks`);
      
  //     const [shisoResponse, shisooaksResponse] = await Promise.all([fetchShiso, fetchShisooaks]);
      
  //     const shisoData = await shisoResponse.json();
  //     shisoData.text.shopId = 'shiso'
  //     const shisooaksData = await shisooaksResponse.json();
  //     shisooaksData.text.shopId = 'shisooaks'
      
  //     setShops([shisoData.text, shisooaksData.text]);
  //   }
  //   fetchShops()
  // }, [0])
  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const response = await fetch(menuURL);
        const data = await response.json();
        console.log('Fetched menu data:', data.menu.subMenus);
        setShop(data);
      } catch (error) {
        console.error('Error fetching menu:', error);
      }
    };
    fetchMenu();
  }, []);

  // console.log("shops:", shops)


  const theme = "light"
  const heroLogoUrl = (theme !== 'dark') ?
    "https://afag.imgix.net/the-kluckin-chicken/kluckin-chicken-logo-1.png?w=500&auto=format" :
    "https://afag.imgix.net/the-kluckin-chicken/kluckin-chicken-logo-1.png?w=500&auto=format"

  return(
    <div className={"site-content  pablitoschicken" + " " + theme}>
      <Headers></Headers>

      <div role="navigation" aria-label="primary" className="cart-wrapper">
      
            <div className="cart minimized">
              <div className="home-link-wrapper">
                <h2>
                  <Link to="/" 
                  aria-label={siteData.shortName + " home page"}
                  className="home-link" aria-label="home page">
                         {/* <img
                          className="nav-bar-logo"
                          src={"https://afag.imgix.net/pablitos-pizza/logo.png?h=400&auto=format"}
                          alt="Pablito's Mexican Pizza"
                        /> */}
                    <img
                          className="nav-bar-logo"
                          src={lancersBadge}
                          alt={siteData.shortName}
                          width="900"
                          height="490"
                   />
                    {/* <span className="text-logo">{!logo && shop.name && shop.name.en}</span> */}
                  </Link>
                </h2>
      
              </div>
      
             
      
              <div className="site-nav-bar" >
                  <MainNavigation />

                  <a className="nav-bar-link call-to-action" href="/order" aria-label="order online for pickup or delivery (choose location)">
                    Order
                  </a>


           
              </div>


              
      
        
            </div>
          </div>


  
      <Switch>

        {multiSitePages.map((page) => (
          <Route key={page.path} path={page.path} component={page.component} />
        ))}
        <Route path="/" exact render={() => {
          return(<MultiHeader shops={shops} shop={shop}></MultiHeader>)
        }}></Route>
        <Route path="/hqusers/storeRedirect/:anything" render={() => {
          return(<Redirect to="/"></Redirect>)
        }}></Route>
        {/* <MultiHeader></MultiHeader> */}
      </Switch>
    </div>
  )
}



function ChristmasPromoCover() {
  return (
    <div className="christmas-promo-cover" aria-label="Christmas Menu Announcement">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Lobster&family=Outfit:wght@400;600;700&display=swap');
        
        @keyframes snowfall {
          0% {
            transform: translateY(-10px) rotate(0deg);
            opacity: 1;
          }
          100% {
            transform: translateY(100vh) rotate(360deg);
            opacity: 0.3;
          }
        }
        
        @keyframes sway {
          0%, 100% { margin-left: 0; }
          25% { margin-left: 15px; }
          75% { margin-left: -15px; }
        }
        
        @keyframes pulse-glow {
          0%, 100% { box-shadow: inset 0 0 60px rgba(212, 168, 75, 0.1); }
          50% { box-shadow: inset 0 0 80px rgba(212, 168, 75, 0.2); }
        }
        
        .christmas-promo-cover {
          --diner-red: #c41e3a;
          --diner-green: #165b33;
          --diner-cream: #fdf6e3;
          --diner-gold: #d4a84b;
          --diner-dark: #2d1f1f;
          
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          min-height: 100vh;
          text-decoration: none;
          background: linear-gradient(170deg, #4a1c1c 0%, #2d1f1f 30%, #1a2e1a 70%, #0f1f0f 100%);
          position: relative;
          overflow: hidden;
          animation: pulse-glow 4s ease-in-out infinite;
        }
        
        .christmas-promo-cover .cover-snowflakes {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          pointer-events: none;
          z-index: 1;
          overflow: hidden;
        }
        
        .christmas-promo-cover .cover-snowflake {
          position: absolute;
          top: -20px;
          color: #fff;
          font-size: 1.5em;
          text-shadow: 0 0 8px rgba(255,255,255,0.8);
          animation: snowfall linear infinite, sway ease-in-out infinite;
          opacity: 0.7;
        }
        
        .christmas-promo-cover .cover-snowflake:nth-child(1) { left: 3%; animation-duration: 10s, 3s; font-size: 1.2em; }
        .christmas-promo-cover .cover-snowflake:nth-child(2) { left: 12%; animation-duration: 14s, 4s; font-size: 1.8em; animation-delay: 1s; }
        .christmas-promo-cover .cover-snowflake:nth-child(3) { left: 22%; animation-duration: 12s, 3.5s; font-size: 1.4em; animation-delay: 0.5s; }
        .christmas-promo-cover .cover-snowflake:nth-child(4) { left: 32%; animation-duration: 16s, 2.5s; font-size: 1.6em; animation-delay: 2s; }
        .christmas-promo-cover .cover-snowflake:nth-child(5) { left: 42%; animation-duration: 11s, 4.5s; font-size: 2em; animation-delay: 1.5s; }
        .christmas-promo-cover .cover-snowflake:nth-child(6) { left: 52%; animation-duration: 13s, 3.2s; font-size: 1.3em; animation-delay: 0.8s; }
        .christmas-promo-cover .cover-snowflake:nth-child(7) { left: 62%; animation-duration: 15s, 3.8s; font-size: 1.5em; animation-delay: 2.5s; }
        .christmas-promo-cover .cover-snowflake:nth-child(8) { left: 72%; animation-duration: 10.5s, 2.8s; font-size: 1.7em; animation-delay: 3s; }
        .christmas-promo-cover .cover-snowflake:nth-child(9) { left: 82%; animation-duration: 14.5s, 3.5s; font-size: 1.1em; animation-delay: 1.2s; }
        .christmas-promo-cover .cover-snowflake:nth-child(10) { left: 92%; animation-duration: 12.5s, 4.2s; font-size: 1.9em; animation-delay: 0.3s; }
        
        .christmas-promo-cover .cover-content {
          position: relative;
          z-index: 2;
          text-align: center;
          padding: 3rem 2rem;
          max-width: 800px;
        }
        
        .christmas-promo-cover .cover-decoration {
          font-size: 1.5em;
          letter-spacing: 12px;
          opacity: 0.5;
          margin-bottom: 1rem;
        }
        
        .christmas-promo-cover .cover-title {
          font-family: 'Lobster', cursive;
          font-size: 4.5rem;
          color: var(--diner-cream);
          margin: 0 0 1rem 0;
          text-shadow: 4px 4px 0 rgba(0,0,0,0.4);
          line-height: 1.1;
        }
        
        .christmas-promo-cover .cover-subtitle {
          font-family: 'Outfit', sans-serif;
          font-size: 1.5rem;
          color: var(--diner-gold);
          text-transform: uppercase;
          letter-spacing: 4px;
          font-weight: 600;
          margin-bottom: 2rem;
        }
        
        .christmas-promo-cover .cover-hours {
          display: flex;
          justify-content: center;
          gap: 2rem;
          flex-wrap: wrap;
          margin-bottom: 2.5rem;
        }
        
        .christmas-promo-cover .cover-hours-item {
          background: rgba(0,0,0,0.4);
          border: 3px solid var(--diner-gold);
          padding: 1rem 2rem;
          border-radius: 8px;
        }
        
        .christmas-promo-cover .cover-hours-day {
          font-size: 1rem;
          color: var(--diner-gold);
          text-transform: uppercase;
          letter-spacing: 2px;
          font-weight: 700;
          margin-bottom: 0.25rem;
        }
        
        .christmas-promo-cover .cover-hours-time {
          font-size: 1.3rem;
          color: var(--diner-cream);
          font-weight: 600;
        }
        
        .christmas-promo-cover .cover-notice {
          font-family: 'Outfit', sans-serif;
          font-size: 1.2rem;
          color: var(--diner-cream);
          margin-bottom: 1.5rem;
          line-height: 1.5;
          padding: 1rem 1.5rem;
          background: rgba(196, 30, 58, 0.3);
          border: 2px solid var(--diner-red);
          border-radius: 8px;
          display: inline-block;
        }
        
        .christmas-promo-cover .cover-cta-section {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1rem;
        }
        
        .christmas-promo-cover .cover-cta {
          display: inline-block;
          background: var(--diner-red);
          color: var(--diner-cream);
          padding: 1rem 2.5rem;
          border: 3px solid var(--diner-gold);
          border-radius: 8px;
          font-family: 'Outfit', sans-serif;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 2px;
          font-size: 1.1rem;
          transition: all 0.3s ease;
          text-decoration: none;
        }
        
        .christmas-promo-cover .cover-cta:hover {
          background: var(--diner-gold);
          color: var(--diner-dark);
          transform: scale(1.05);
        }
        
        .christmas-promo-cover .cover-secondary-link {
          display: inline-block;
          background: var(--diner-green);
          color: var(--diner-cream);
          padding: 1rem 2.5rem;
          border: 3px solid var(--diner-gold);
          border-radius: 8px;
          font-family: 'Outfit', sans-serif;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 2px;
          font-size: 1.1rem;
          transition: all 0.3s ease;
          text-decoration: none;
        }
        
        .christmas-promo-cover .cover-secondary-link:hover {
          background: var(--diner-gold);
          color: var(--diner-dark);
          transform: scale(1.05);
        }
        
        @media (max-width: 768px) {
          .christmas-promo-cover .cover-content {
            padding: 2rem 1rem;
          }
          .christmas-promo-cover .cover-decoration {
            font-size: 1em;
            letter-spacing: 8px;
          }
          .christmas-promo-cover .cover-title {
            font-size: 2.5rem;
          }
          .christmas-promo-cover .cover-subtitle {
            font-size: 1rem;
            letter-spacing: 2px;
          }
          .christmas-promo-cover .cover-hours {
            flex-direction: column;
            gap: 1rem;
          }
          .christmas-promo-cover .cover-hours-item {
            padding: 0.75rem 1.5rem;
          }
          .christmas-promo-cover .cover-hours-day {
            font-size: 0.85rem;
          }
          .christmas-promo-cover .cover-hours-time {
            font-size: 1.1rem;
          }
          .christmas-promo-cover .cover-notice {
            font-size: 1rem;
            padding: 0.75rem 1rem;
          }
          .christmas-promo-cover .cover-cta,
          .christmas-promo-cover .cover-secondary-link {
            padding: 0.75rem 1.5rem;
            font-size: 0.9rem;
          }
        }
        
        @media (max-width: 480px) {
          .christmas-promo-cover .cover-title {
            font-size: 2rem;
          }
          .christmas-promo-cover .cover-subtitle {
            font-size: 0.85rem;
            letter-spacing: 1px;
          }
          .christmas-promo-cover .cover-notice {
            font-size: 0.9rem;
          }
        }
      `}</style>
      
      <div className="cover-snowflakes" aria-hidden="true">
        <div className="cover-snowflake">❄</div>
        <div className="cover-snowflake">❅</div>
        <div className="cover-snowflake">❆</div>
        <div className="cover-snowflake">❄</div>
        <div className="cover-snowflake">❅</div>
        <div className="cover-snowflake">❆</div>
        <div className="cover-snowflake">❄</div>
        <div className="cover-snowflake">❅</div>
        <div className="cover-snowflake">❆</div>
        <div className="cover-snowflake">❄</div>
      </div>
      
      <div className="cover-content">
        <div className="cover-decoration">❄ ❄ ❄</div>
        <h2 className="cover-title">🎄 Christmas Menu 🎄</h2>
        <p className="cover-subtitle">Christmas Eve & Christmas Day</p>
        
        <div className="cover-hours">
          <div className="cover-hours-item">
            <div className="cover-hours-day">Dec. 24</div>
            <div className="cover-hours-time">7 AM – 2 PM</div>
          </div>
          <div className="cover-hours-item">
            <div className="cover-hours-day">Dec. 25</div>
            <div className="cover-hours-time">8 AM – 5 PM</div>
          </div>
        </div>
        
        <div className="cover-cta-section">
          <div className="cover-notice">
            Come back on Dec. 24 to place your order here!
          </div>
          <Link to="/christmas" className="cover-cta">View Christmas Menu</Link>
          <Link to="/order" className="cover-secondary-link">
            Order Regular Menu – Pickup & Delivery
          </Link>
        </div>
      </div>
    </div>
  );
}

function MultiHeader({shops, shop}) {
  const [open, setOpen] = useState(true);

  const now = new Date();
  const promoStart = new Date(2026, 1, 27);
  const promoEnd   = new Date(2026, 2, 23);
  const showStPatricks = now >= promoStart && now < promoEnd;

  // Easter 2026: April 5. Show banner from April 3 through April 6.
  const easterStart = new Date(2026, 3, 3);
  const easterEnd   = new Date(2026, 3, 7); // day after April 6
  const showEaster = now >= easterStart && now < easterEnd;

  // Mother's Day 2026: Sunday May 10. Specials run Sat May 9 & Sun May 10.
  // Show banner from May 4 through May 10.
  const mothersStart = new Date(2026, 4, 4);
  const mothersEnd   = new Date(2026, 4, 11); // day after May 10
  const showMothers  = now >= mothersStart && now < mothersEnd;

  // Father's Day 2026: Sunday June 21. Specials run Sat June 20 (7am-10pm) & Sun June 21 (7am-8pm).
  // Show banner from June 14 through 11pm Sunday June 21.
  const fathersStart = new Date(2026, 5, 14);
  const fathersEnd   = new Date(2026, 5, 21, 23, 0, 0); // 11pm Sun, June 21
  const showFathers  = now >= fathersStart && now < fathersEnd;

  return (
    <div className="landing-page-wrapper lancers-2026">

      <div className="home-grid">

        <header className="l-hero">
          <div className="l-hero-inner">
            <img
              className="l-hero-badge"
              src={lancersBadge}
              alt={siteData.shortName}
              width="900"
              height="490"
            />
            <p className="l-hero-tagline">
              Burbank&rsquo;s hidden gem for hearty, handcrafted American comfort food.
            </p>
            <p className="l-hero-meta">Burbank, California</p>
            <div className="l-hero-actions">
              <Link className="l-btn l-btn-primary" to="/order">
                Order Online
              </Link>
              <Link
                className="l-btn l-btn-ghost"
                to="/full-menu"
                aria-label="view our full menu"
              >
                Full Menu
              </Link>
            </div>
          </div>
        </header>

        {showFathers ? <FathersDayPromo /> : showMothers ? <MothersDayPromo /> : showEaster ? <EasterPromo /> : (shop ? <ProductSlideshow
          ratio="4 / 3"
          categories={shop.menu.subMenus}
          promoSlide={showStPatricks ? <StPatricksPromo /> : null}
        /> : null)}

        <section className="l-section">
          <div className="site-intro">
            <h2 className="header-text">
              Burbank&rsquo;s hidden gem for hearty, handcrafted American comfort food.
            </h2>

            <Star />

            <p className="body-text">
              We specialize in classic breakfasts, homestyle lunches, comfort-food dinners, and timeless diner favorites made fresh daily!
            </p>
            <p className="body-text">
              Fresh ingredients, generous portions, and warm service &mdash; dine in, pick up, or order delivery!
            </p>
          </div>
        </section>

        <div className="split-section">
          <div className="split-image" style={{
            flex: '1',
            backgroundImage: 'url("https://afag.imgix.net/lancers-family-restaurant/hero.jpeg?w=900&auto=format")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            minHeight: '400px'
          }}></div>
          <div className="split-content" style={{
            flex: '1',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center'
          }}>
            <h3 className="split-title">
              Burbank&rsquo;s Favorite Diner
            </h3>
            <p className="split-text">
              Welcome to Lancers Family Restaurant, a Burbank staple proudly serving the community for over five decades. Known for our classic American comfort food, generous portions, and friendly neighborhood atmosphere, we&rsquo;re the place people come to relax, gather, and feel at home. Whether you&rsquo;re craving a hearty breakfast, a homestyle lunch, or a satisfying dinner, our menu is filled with timeless favorites made with care. Join us at Lancers&mdash;where great food and warm hospitality are always on the menu.
            </p>
            <p className="split-text">
              <Link to="/burbank/order">Explore Our Menu</Link>
            </p>
          </div>
        </div>

        {shop ? (
          <section className="l-section">
            <div className="l-hex">
              <h2 className="l-hex-title">From the Menu</h2>
            </div>
            <MenuCategoriesPreview categories={shop.menu.subMenus} />
          </section>
        ) : null}

        <div className="l-locations-heading">
          <div className="l-hex is-teal">
            <h2 className="l-hex-title">Our Locations</h2>
          </div>
        </div>
        <LocationsView shops={shops} />
      </div>
    </div>
  );
}




export class Header extends PureComponent {
  render() {
    // console.log('header props:', this.props)
    const shopId = this.props.shopId
    const basePath = this.props.basePath
    const locationName = this.props.shopId === 'shiso' ? 'North Hollywood' : 'Sherman Oaks'


    const backgroundULRBase = (basePath === '/shermanoaks') ?
    "https://afag.imgix.net/the-kluckin-chicken/nuggets.jpeg?w=1200&auto=format"
    : "https://afag.imgix.net/the-kluckin-chicken/kluckin-ten.png?w=1200&auto=format"
    return (
      <div className="location-page">

      {/* <Helmet>
        <title>Sushi Yu | Order Online</title>
      </Helmet> */}
      
        <div className="top-banner" style={{
          // backgroundImage: `url(${backgroundULRBase})`,
          // backgroundColor: "rgb(238,143,33)",
          // background:  `url(${backgroundULRBase}), linear-gradient(180deg, rgba(238,143,33,1) 0%, rgba(226,90,39,1) 100%)`,
          // backgroundSize: "contain",
          // background: "black"
        }}> 

        </div>

       

      <h2 id="order" style={{visibility: 'hidden', height: "0px", margin: "0", padding: "0"}}>Order Online</h2>

        <div className="ordering-menu">
          <AutoMenu
            subMenuFilter={subMenuFilter}
            altStyleA
            darkMode={true}
            // tagsToShow={['pizza']}
            width={500}></AutoMenu>
        </div>
      </div>
    );
  }
}


export function subMenuFilter (subMenu) {
  const tag = subMenu.tag || ''
  const now = new Date()
  const day = now.getDay() // Sunday - Saturday : 0 - 6
  const hours = now.getHours() //0 to 23
  const minutes = now.getMinutes() // 0 to 59
  const isWeekday = [1,2,3,4,5].indexOf(day) !== -1
  const isAllDayBreakfastMenu = tag.indexOf('breakfast') !== -1
  const isHidden = tag.indexOf('hidden') !== -1
  if (tag.indexOf('lunch') !== -1) {
    // thursday promo category
    if (isWeekday && (hours >= 11) && (hours < 16)) {
      return true
    } else {
      return false
    }
  }
  if (tag.indexOf('thursdays-only') !== -1) {
    // thursday promo category
    if (day === 4) {
      return true
    } else {
      return false
    }
  }
  if (tag.indexOf('tuesday-only') !== -1) {
    // thursday promo category
    if (day === 2) {
      return true
    } else {
      return false
    }
  }
  if (tag.indexOf('noho-breakfast') !== -1) {
    if ((day === 1) || (day === 2)) {
      if ((hours > 0) && (hours < 16)) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }
  if (tag.indexOf('noho-dinner') !== -1) {
    return true
    // thursday promo category
    // if ((day === 1) || (day === 2)) {
    //   if ((hours > 16)) {
    //     return true
    //   } else {
    //     return false
    //   }
    // } else {
    //   return true
    // }
  }

  if (tag.indexOf('promo-wing-it-wed') !== -1) {
    // wednesday promo category
    if (day === 3) {
      return true
    } else {
      return false
    }
  }

  if (isHidden) {
    return false
  }

  if (isAllDayBreakfastMenu && isWeekday) {
    return false
  }


  return true
}